import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExternalResourcesLoaderService {
  private externalResourcesLoaded = new Set<string>();

  /* istanbul ignore next: there is no mock for script loading */
  public async load(document: Document, jsFiles: string[], cssFiles: string[] = [], force = false): Promise<void> {
    await jsFiles
      .filter((file) => !this.externalResourcesLoaded.has(file) || force)
      .reduce(async (promise, url) => {
        await promise;
        return new Promise((resolve, reject) => {
          this.createAndAppendScript(document, url, resolve, reject);
        });
      }, Promise.resolve());

    cssFiles
      .filter((file) => !this.externalResourcesLoaded.has(file) || force)
      .forEach((url) => {
        const css: HTMLLinkElement = document.createElement('link');
        css.setAttribute('href', url);
        css.setAttribute('rel', 'stylesheet');
        css.setAttribute('type', 'text/css');
        document.head.appendChild(css);
        this.externalResourcesLoaded.add(url);
      });
  }

  private createAndAppendScript(document, url, resolve, reject) {
    const script: HTMLScriptElement = document.createElement('script');
    script.setAttribute('src', url);
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
    this.externalResourcesLoaded.add(url);
  }
}
